import Poem from "../components/Poem/Poem";

function PoemPage() {
  return (
    <div className="page poem-page">
      <Poem />
    </div>
  );
}

export default PoemPage;
